module.exports = function() {
  return new Worker(__webpack_public_path__ + "00484e926170447c9d6c.worker.js");
};